import React, { Component } from 'react';
import { Big3Common } from '../../../js/IncludeManager'
import { HeaderSub2 } from '../../Common/HeaderSub2'
import { HeaderSub } from '../../Common/HeaderSub'
import { RtiQstList } from './RtiQstList';
import { RtiQstGrp } from './RtiQstGrp';
import { RtiQstDtl } from './RtiQstDtl';
import { StockQst } from './StockQst';
import { StockQstCon } from './StockQstCon';
import { Footer } from '../../Common/Footer'
/* 개발담당:양유빈
 * 화면기능:문의관리 인덱스
 * 세부설명:
*/

export class Index extends Component {
    static displayName = Index.name;

    constructor(props) {
        super(props);
        this.Param_Qstgrp_no = Big3Common.Util.GetParams("qstgrp_no");       //링크주소가 있을때
        this.Param_Union_Uid = Big3Common.Util.GetParams("union_uid");
        this.Param_Whole_Name = Big3Common.Util.GetParams("whole_name");

        this.state = {
            RenderName: this.CompName.RtiQstGrp,  //기본 컴포넌트 할당
            ContentState: null
        };
        this.CsName = Big3Common.ContentState;
    }
    //호출할 컴포넌트 이름
    CompName = {
        "RtiQstGrp": "RtiQstGrp",
        "RtiQstList": "RtiQstList",
        "RtiQstDtl": "RtiQstDtl",
        "StockQst":"StockQst",
        "StockQstCon": "StockQstCon"
    }
    //초기화
    componentDidMount() {
        
        if (this.Param_Qstgrp_no !== null && this.Param_Union_Uid !== null && this.Param_Whole_Name !== null) {
            //구매내역에서 직접 채팅으로 넘길때
            const ContentState = {
                [this.CsName.QstgrpNo]: this.Param_Qstgrp_no,
                [this.CsName.SearchText]: "",
                [this.CsName.Whole_Name]: this.Param_Whole_Name,
                [this.CsName.Union_Uid]: this.Param_Union_Uid
            }
            this.setState({
                ContentState: ContentState,
                RenderName: this.CompName.RtiQstDtl
            });
        }
    }
    componentWillUnmount() {
        Big3Common.HistoryBackToClearBackdoor();
    }
    renderPick() {
        if (this.state.RenderName === this.CompName.RtiQstGrp) {
            //소매 리스트(문의가 1번이상있는 소매)
            return (
                <div>
                    <HeaderSub2
                        HeaderTitle="주문문의"
                        LinkUrl="/"
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                        ComponentName={this.state.RenderName}
                      
                    />
                    <RtiQstGrp
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />
                    <Footer
                        fillName="icon4"
                        ComponentName={this.state.RenderName}
                    />
                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.RtiQstList) {
             //소매별 채팅 리스트
            let Title = Big3Common.Util.GetContentState(this.state.ContentState, this.CsName.Whole_Name, "");
            return (
                <div>
                    <HeaderSub
                        HeaderTitle={Title }
                        ComponentUrl="RtiQstGrp"
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ComponentName={this.state.RenderName}
                        ContentState={this.state.ContentState}

                    />
                    <RtiQstList
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />
                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.RtiQstDtl) {
            //채팅창
            let Title = Big3Common.Util.GetContentState(this.state.ContentState, this.CsName.Whole_Name, "");
            let HistoryBack = false
            if (this.Param_Qstgrp_no !== null && this.Param_Union_Uid !== null && this.Param_Whole_Name !== null) {
                //로직상 HistoryBack 속성을 먼저 만나고 true이면 실행, 아니면 다음 로직 처리 함으로 HistoryBack-->ComponentUrl 까지 처리 할수 있음.
                HistoryBack = true;
            }
            return (
                <div>
                    <HeaderSub
                        HeaderTitle={Title}
                        HistoryBack={HistoryBack }
                        ComponentUrl="RtiQstList"
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ComponentName={this.state.RenderName}
                        ContentState={this.state.ContentState}

                    />
                    <RtiQstDtl
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />
                </div>
            );
           
        }
        else if (this.state.RenderName === this.CompName.StockQst) {
            //재고문의 화면
            return (
                <div>
                    <HeaderSub
                        HeaderTitle="재고문의"
                        ComponentUrl="RtiQstDtl"
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ComponentName={this.state.RenderName}
                        ContentState={this.state.ContentState}
                    />
                    <StockQst
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />
                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.StockQstCon) {
            //주문이 된 후 상태에 따른 페이지 뷰
            const QstStatus=Big3Common.Util.GetContentState(this.state.ContentState, this.CsName.QstStatus, "");
            let Title = "";
            if (QstStatus === "QA") {
                Title = "재고문의";
            }
            else if (QstStatus === "AN") {
                Title = "재고답변";
            }
            else if (QstStatus === "JM") {
                Title = "상품주문";
            }
            else if (QstStatus === "PJ") {
                Title = "포장완료";
            }
            else if (QstStatus === "GR") {
                Title = "거래완료";
            }
            else if (QstStatus === "CS") {
                Title = "주문취소";
            }
            return (
                <div>
                    <HeaderSub
                        HeaderTitle={Title}
                        ComponentUrl="RtiQstDtl"
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ComponentName={this.state.RenderName}
                        ContentState={this.state.ContentState}
                    />
                    <StockQstCon
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />
                </div>
            );
        }
        else {
            return ("");
        }
    }

    render() {
        let RnderAct = this.renderPick();
        return (
            <div>
                {RnderAct}
            </div>
        );
    }
}
